import React from 'react';
import { BrowserRouter, Routes, Route, Link, useLocation } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { CartProvider } from './context/CartContext';
import Welcome from './components/client/Welcome';
import StandList from './components/client/StandList';
import StandMenu from './components/client/StandMenu';
import Cart from './components/client/Cart';
import Checkout from './components/client/Checkout';
import OrderTracking from './components/client/OrderTracking';
import BODashboard from './components/backoffice/Dashboard';
import BOOrders from './components/backoffice/Orders';
import BOInventory from './components/backoffice/Inventory';
import BOProductForm from './components/backoffice/ProductForm';
import BOClients from './components/backoffice/Clients';
import BOAnalytics from './components/backoffice/Analytics';
import ChatBot from './components/client/ChatBot';
import Login from './components/client/Login';
import StandLogin from './components/backoffice/StandLogin';

function BackofficeLayout({ children }) {
  const location = useLocation();
  const standId = location.pathname.split('/')[2] || '1';
  const tabs = [
    { path: `/backoffice/${standId}`, label: 'Commandes' },
    { path: `/backoffice/${standId}/inventory`, label: 'Inventaire' },
    { path: `/backoffice/${standId}/clients`, label: 'CRM Clients' },
    { path: `/backoffice/${standId}/analytics`, label: 'Analytics' },
  ];

  return (
    <div className="min-h-screen bg-[#FEFCF8]">
      <header className="bg-white border-b border-[#E2D1B8]">
        <div className="max-w-7xl mx-auto px-4 py-4 flex items-center justify-between">
          <Link to="/backoffice" className="font-serif text-[#C4673D] text-xl font-bold">
            Back-Office Les Halles
          </Link>
          <Link to="/" className="text-sm text-[#8B7355] border border-[#E2D1B8] px-3 py-1.5 rounded-lg hover:text-[#C4673D] hover:border-[#C4673D] transition">
            Vue Client
          </Link>
        </div>
        <nav className="max-w-7xl mx-auto px-4 flex gap-6">
          {tabs.map(t => (
            <Link
              key={t.path}
              to={t.path}
              className={`px-1 py-3 text-sm font-medium transition ${location.pathname === t.path ? 'text-[#C4673D] border-b-2 border-[#C4673D]' : 'text-[#8B7355] hover:text-[#C4673D] border-b-2 border-transparent'}`}
            >
              {t.label}
            </Link>
          ))}
        </nav>
      </header>
      <main className="max-w-7xl mx-auto p-4">{children}</main>
    </div>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
      <CartProvider>
        <Routes>
          {/* Auth */}
          <Route path="/login" element={<Login />} />
          <Route path="/stand-login" element={<StandLogin />} />
          {/* Client */}
          <Route path="/" element={<Welcome />} />
          <Route path="/order" element={<StandList />} />
          <Route path="/order/table/:tableId" element={<StandList />} />
          <Route path="/stand/:id" element={<StandMenu />} />
          <Route path="/cart" element={<Cart />} />
          <Route path="/checkout" element={<Checkout />} />
          <Route path="/tracking/:orderId" element={<OrderTracking />} />
          {/* Back-office */}
          <Route path="/backoffice" element={<BackofficeLayout><BODashboard /></BackofficeLayout>} />
          <Route path="/backoffice/:standId" element={<BackofficeLayout><BOOrders /></BackofficeLayout>} />
          <Route path="/backoffice/:standId/inventory" element={<BackofficeLayout><BOInventory /></BackofficeLayout>} />
          <Route path="/backoffice/:standId/product/:productId" element={<BackofficeLayout><BOProductForm /></BackofficeLayout>} />
          <Route path="/backoffice/:standId/product/new" element={<BackofficeLayout><BOProductForm /></BackofficeLayout>} />
          <Route path="/backoffice/:standId/clients" element={<BackofficeLayout><BOClients /></BackofficeLayout>} />
          <Route path="/backoffice/:standId/analytics" element={<BackofficeLayout><BOAnalytics /></BackofficeLayout>} />
        </Routes>
        <ChatBot />
      </CartProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}
